export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=403401ad06341a598b34f19e30cb5d743419b86292&name=revalidateCommunity!'